import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/form-elements/button';

const Modal = (props) => {
    const {
        show = false,
        title,
        actionLabel,
        actionCallback
    } = props;

    return (
        <>
            { show  ? (
                <div className='fixed top-0 left-0 inset-0 bg-black/50'>
                    <div aria-hidden="true" className="flex justify-center items-center w-full mx-auto max-w-lg p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
                        <div className="relative w-full max-w-2xl max-h-full">
                            <div className="relative bg-white rounded-lg shadow">
                                <div className="flex items-start justify-between p-4 border-b rounded-t">
                                    <h3 className="font-semibold text-gray-900">
                                        {title}
                                    </h3>
                                </div>
                                <div className="p-4 space-y-4 text-sm">
                                    {props.children}
                                </div>
                                <div className="flex items-center p-4 space-x-2 border-t border-gray-200 rounded-b">
                                    <Button onClick = {actionCallback}>{actionLabel}</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ) : null
            }
        </>
    )
};

Modal.propTypes = {
    show : PropTypes.bool,
    title: PropTypes.string,
    actionLabel: PropTypes.string,
    actionCallback : PropTypes.func
};

export default Modal;